import React from 'react';
import PropTypes from 'prop-types';
import {FmlxIcon, FmlxTooltip} from 'fmlx-common-ui';

import TipIndicator from './TipIndicator';

import withIntl from '../../../lib/withIntl';

import './TipCapacityStatus.scss';
import {TaskType} from '../../../constants/dataEnum';

function TipCapacityStatus({
  onClose,
  taskAspirateAirGapVolume,
  bubblePercentage,
  minCapacity,
  maxCapacity,
  value,
  currentTipVolume,
  intl,
  taskType,
  highVolume,
}) {
  const showExceedingVolumeTooltip = () => {
    if (taskType === TaskType.AIR_GAP) {
      return false;
    }
    const deltaVolume = parseFloat(value);
    const tipVolume = parseFloat(currentTipVolume);

    return tipVolume + deltaVolume > maxCapacity;
  };

  const getTaskAspirateAirGapVolume = () => {
    const taskVolume = [
      ...taskAspirateAirGapVolume,
      {
        type: taskType,
        volume: value,
      },
    ];
    return taskVolume;
  };

  return (
    <div className={`tip-capacity-status ${highVolume ? 'high-volume' : ''}`}>
      <div className="tip-capacity-status-header">
        <img src="./svg/protocol-editor/small-close.svg" alt="Close" onClick={onClose} role="presentation" />
      </div>
      <div className="title">
        <p>{intl.formatMessage({id: 'protocolEditor.tipCapacityStatus.title'})}</p>
        {showExceedingVolumeTooltip() && (
          <>
            <p>&nbsp;</p>
            <FmlxTooltip title={intl.formatMessage({id: 'protocolEditor.tipCapacityStatus.info'})} placement="right">
              <span>
                <FmlxIcon name="InfoOutline" size="xs" customColor="white" />
              </span>
            </FmlxTooltip>
          </>
        )}
      </div>
      <TipIndicator
        taskAspirateAirGapVolume={getTaskAspirateAirGapVolume()}
        bubblePercentage={bubblePercentage}
        minCapacity={minCapacity}
        maxCapacity={maxCapacity}
        initialVolume={currentTipVolume}
        highVolume={highVolume}
      />
    </div>
  );
}

TipCapacityStatus.propTypes = {
  taskAspirateAirGapVolume: PropTypes.any.isRequired,
  bubblePercentage: PropTypes.number,
  onClose: PropTypes.func,
  minCapacity: PropTypes.number,
  maxCapacity: PropTypes.number,
  value: PropTypes.number,
  currentTipVolume: PropTypes.number,
  intl: PropTypes.any.isRequired,
  taskType: PropTypes.any.isRequired,
  highVolume: PropTypes.bool,
};

TipCapacityStatus.defaultProps = {
  bubblePercentage: 0,
  onClose: () => {},
  minCapacity: 0,
  maxCapacity: 13,
  currentTipVolume: 0,
  value: 0,
  highVolume: false,
};

export default withIntl(TipCapacityStatus);
